module.exports = __webpack_public_path__ + "img/galerie-29.1a263b61.jpg";